import React from 'react';
import { useSelector } from 'react-redux';
import { TooltipHost } from '@fluentui/react';
import { selectEmailTemplatesState } from './emailTemplatesState';
import { styles } from './EmailTemplateAdmin.styled';

interface VariableInsertPanelProps {
  onInsert: (variableText: string) => void;
}

export const VariableInsertPanel: React.FC<VariableInsertPanelProps> = ({ onInsert }) => {
  const variables = useSelector((state: { dynamic?: Record<string, unknown> }) => selectEmailTemplatesState(state).variables);

  const handleClick = (name: string) => {
    onInsert(`{{${name}}}`);
  };

  if (variables.length === 0) {
    return null;
  }

  return (
    <div className={styles.variablesPanel} role="region" aria-label="Template variables">
      <div className={styles.variablesPanelTitle}>
        Available Variables (click to insert at cursor)
      </div>
      <div className={styles.variableTagsContainer}>
        {variables.map((variable) => (
          <TooltipHost
            key={variable.name}
            content={`${variable.description} — Example: ${variable.example}`}
          >
            <button
              className={styles.variableTag}
              onClick={() => handleClick(variable.name)}
              aria-label={`Insert variable ${variable.name}: ${variable.description}`}
              type="button"
            >
              {variable.name}
            </button>
          </TooltipHost>
        ))}
      </div>
    </div>
  );
};
